import _get from 'lodash/get';
import React, { Fragment } from 'react';
import Badge from 'react-bootstrap/Badge';
import { isMobile } from 'react-device-detect';
import { Table } from '@ai4/records-management';
import { Permission, Role } from 'src/types';

interface Props {
	permissions: Permission[];
	showAddButton?: boolean;
	showRemoveButton?: boolean;
	onRemovePermission?: (permission: Permission, role: Role) => void;
	onAddPermission?: (permission: Permission) => void;
}

export function PermissionsList(props: Props) {
	const { permissions, showAddButton, showRemoveButton, onRemovePermission, onAddPermission } = props;

	const COLUMNS = [
		{
			dataField: 'id',
			text: 'ID',
			hidden: true,
		},
		{
			dataField: 'name',
			text: 'Funzione',
			sort: true,
			formatter: (cell: any, row: any) => {
				const description = isMobile ? null : (
					<div>
						<span className='row-subtitle'>{row.description}</span>
					</div>
				);
				return (
					<div>
						<span>{row.name}</span>
						{description}
					</div>
				);
			},
		},
		{
			dataField: '',
			text: 'Ruoli',
			style: { width: '30%' },
			formatter: (cell: any, row: any) => {
				const roles = _get(row, 'roles', []);
				return (
					<Fragment>
						{roles.map((role: Role) => {
							return (
								<div key={role.id}>
									<Badge style={{ marginRight: '5px' }}>
										{role.name}{' '}
										{showRemoveButton && (
											<a
												href='#'
												style={{ color: '#fff', fontWeight: 'bold' }}
												onClick={() => {
													if (onRemovePermission) onRemovePermission(row, role);
												}}
											>
												x
											</a>
										)}
									</Badge>
								</div>
							);
						})}
						{showAddButton && (
							<Badge bg='success' style={{ marginRight: '5px' }}>
								<a
									href='#'
									style={{ color: '#fff', fontWeight: 'bold' }}
									onClick={() => {
										if (onAddPermission) onAddPermission(row);
									}}
								>
									Aggiungi un ruolo
								</a>
							</Badge>
						)}
					</Fragment>
				);
			},
		},
	] as any;

	/*
	if (showRemoveButton) {
		COLUMNS.push({
			dataField: 'remove',
			text: '',
			editable: false,
			align: 'center',
			headerStyle: { width: 30 },
			formatter: (cell: any, row: any) => {
				return (
					<button type='button' className='btn btn-action'>
						<i
							className='bi bi-x-lg'
							onClick={() => {
								// onRemovePermission(row);
							}}
						>
							<span className='visually-hidden'>rimuovi</span>{' '}
						</i>
					</button>
				);
			},
		});
	}
	*/

	const rows = permissions;

	return (
		<div>
			<Table
				columns={COLUMNS}
				rows={rows}
				hidePagination
				hideToggle
				hideEditColumns
				onSelectedRow={() => {}}
				onDeleteRow={() => {}}
			/>
		</div>
	);
}

export default PermissionsList;
